import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessaoService } from './sessao.service';

/**
 * Bloqueia rotas que exigem identificação do estagiário (AC03).
 * Sem nome salvo → redireciona para /sessao guardando a rota pretendida
 * em `returnUrl`, para retornar a ela após a identificação.
 */
export const sessaoGuard: CanActivateFn = (_route, state) => {
  const sessao = inject(SessaoService);
  const router = inject(Router);

  if (sessao.autenticado()) {
    return true;
  }
  return router.createUrlTree(['/sessao'], {
    queryParams: { returnUrl: state.url },
  });
};
